<template>
  <div id ="app" class="t_container">
    <div class="pageTitle">CoreMark测试结果</div>
    <div class="header">
      <div class="headerText" :style="{paddingRight:isMoPhone?'0px':'105px'}">CoreMark是行业内衡量MCU性能的常用基准测试工具，提供一套标准化方法来测试单位时间内运行的CoreMark程序次数。测试得分数值越大通常说明MCU性能越好，仅供参考。</div>
      <div class="headerImg" v-if="!isMoPhone">
        <img style="margin-left:18px" src="@/assets/imgs/computerIcon.png" alt="">
      </div>
    </div>
    <!-- 表格 -->
    <div class="selectModel">
      <div class="tableClass" v-loading="loading">
        <el-table
          :data="tableData"
          :span-method="objectSpanMethod"
          border
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column :fixed="true" prop="xh" label="Part No." align="center" width="110">
            <template slot-scope="scope">
              <a v-if="scope.row.url" style="color:#0071d5" :href="scope.row.url" target="_blank">{{scope.row.xh}}</a>
              <span v-else style="color:#0071d5">{{scope.row.xh}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="freq" label="Core Frequency"  align="center" min-width="130"></el-table-column>
          <el-table-column prop="coremark" label="CoreMark"  align="center" min-width="80"></el-table-column>

          <el-table-column label="CoreMark/MHz" align="center" >
            <el-table-column  label="Default Run Configurations" align="center" >
              <el-table-column prop="zero" align="center" min-width="100">
                <template slot="header">Zero wait<br/>code region</template>
              </el-table-column>
              <el-table-column prop="non-zero" align="center" min-width="150">
                <template slot="header">Non-zero wait<br/>code region</template>
              </el-table-column>
            </el-table-column>
            <el-table-column  label="Optional Run Configurations" align="center" >
              <el-table-column prop="run in sram" align="center" min-width="55">
                <template slot="header">
                  <span style="word-break: break-word;">
                   Run in SRAM
                  </span>
                </template>
              </el-table-column>
              <el-table-column  align="center" width="240">
                <template slot="header">Run in async Flash</template>
                <el-table-column prop="score/mhz" align="center" min-width="120">
                  <template slot="header">
                    <span style="word-break: break-word;">
                    CoreMark/Core Freq.
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="flash freqquency" align="center" min-width="90">
                  <template slot="header">
                    <span style="word-break: break-word;">
                    Flash Frequency
                    </span>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
            <el-table-column prop="other"  align="center" min-width="160">
              <template slot="header" ><span style="word-break: break-word;">Other Compilation Environments</span></template>
            </el-table-column>
          </el-table-column>
          
        </el-table>
      </div>
      <div class="tips">
        <div>注：如无特殊说明，测试使用的编译器为相同大版本的GCC编译器；搭载青稞RISC-V内核的MCU使用的编译器为GCC 12.2.0，搭载Arm内核的MCU使用的编译器为GCC 12.2.1；</div>
        <div style="text-indent: 2em;">优化选项为“-Ofast&nbsp; -funroll-all-loops&nbsp; -finline-limit=600&nbsp; -ftree-dominator-opts&nbsp; -fno-if-conversion2&nbsp; -fselective-scheduling&nbsp; -fno-code-hoisting”；</div>
        <div style="text-indent: 2em;">* V5F内核的Icache容量为32KB，可缓存所有基准测试代码。因此，开启该缓存后的性能表现与紧耦合存储器（TCM）相近。若代码容量超过32KB，其性能可能低于该水平。</div>
      </div>
    </div>
    
  </div>
</template>
 
<script>
  import {tableDataHttp } from '@/request/api.js'
  export default {
    name:'home',
    data() {
      return{
        windowWidth: window.innerWidth,
        isMoPhone:false,
        loading:false,
        tableData:[],
      }
    },
    computed: {

    },
    created() {
      window.addEventListener('resize', this.handleResize)
    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    watch: {
      windowWidth(newWidth, oldWidth) {
        if (newWidth <= 900) {
          this.isMoPhone = true
        }else{
          this.isMoPhone = false
        }
      }
    },
    activated(){
    },
    mounted(){
      if (this.windowWidth <= 900) {
        this.isMoPhone = true
      }else{
        this.isMoPhone = false
      }
      this.getTableData()
      console.log('isMoPhone---',this.isMoPhone)
    },
    methods:{
      handleResize() {
        this.windowWidth = window.innerWidth
      },
      getTableData(){
        let params = {
          categoryId:5 
        }
        tableDataHttp(params).then(res => {
          this.loading = true;
          if(res.data.code===0 && res.data.data.length){
            this.tableData = JSON.parse(res.data.data[0].value)
            console.log('tableData---',this.tableData)
          }else{
            this.$message.error(res.data.message);
          }
          this.loading = false;
        });
      },
      //合并行
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        // if(columnIndex==6 ){
          // console.log('row',row)
          // console.log('column',column)
          // console.log('rowIndex',rowIndex)
          // console.log('columnIndex',columnIndex)
        //   if(rowIndex==1){
        //     return {
        //       rowspan: 3,
        //       colspan: 1
        //     };
        //   }else if(rowIndex==2||rowIndex==3||rowIndex==5||rowIndex==6||rowIndex==7){
        //     return {
        //       rowspan: 0,
        //       colspan: 1
        //     };
        //   }else if(rowIndex==4){
        //     return {
        //       rowspan: 4,
        //       colspan: 1
        //     };
        //   }else{
        //     return {
        //       rowspan: 1,
        //       colspan: 1
        //     };
        //   }
        // }


        //定义需要合并的列字段，有哪些列需要合并，就自定义添加字段即可
          const fields = ['xh','run in sram','freq','coremark','zero']
          // 当前行的数据
          const cellValue = row[column.property]
          // 判断只合并定义字段的列数据
          if (cellValue && fields.includes(column.property)) {
            const prevRow = this.tableData[rowIndex - 1] //上一行数据
            let nextRow = this.tableData[rowIndex + 1] //下一行数据
            // 当上一行的数据等于当前行数据时，当前行单元格隐藏
            if (prevRow && prevRow[column.property] === cellValue) {
              return { rowspan: 0, colspan: 0 }
            } else {
              // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
              let countRowspan = 1 //用于合并计数多少单元格
              while (nextRow && nextRow[column.property] === cellValue) {
                nextRow = this.tableData[++countRowspan + rowIndex] //更新下一行
              }
              if (countRowspan > 1) {
                return { rowspan: countRowspan, colspan: 1 }
              }
            }
          }
      },
    }
  };
</script>
  
<style lang='less' scoped>
  .t_container {
    // width: 100%;
    margin: 0;
    font-family: Microsoft YaHei, Arial, Helvetica, sans-serif !important;
    text-align: left;
    background: url('~@/assets/imgs/pageBg.png') no-repeat;
    background-size: 100% 100%;
    padding: 30px;
  }
    .pageTitle{
      width: 264px;
      height: 80px;
      background: url('~@/assets/imgs/titleBg.png') no-repeat;
      color: #fff;
      font-size: 24px;
      text-align: center;
      line-height: 80px;
      font-weight: 600;
    }
    /* 头部 */
    .header{
      width: 100%;
      box-sizing: border-box;
      border: 2px dashed #27e3ff;
      padding: 15px;
      margin-top: 20px;
      position: relative;
      .headerText{
        color: #333;
        font-size: 18px;
        line-height: 24px;
        font-weight: 600;
        padding-right: 85px;
      }
      .headerImg{
        position: absolute;
        right: -8px;
        top: -50px;
        z-index: 10;
        width: 120px;
        background: #f2f5fd;
      }
    }
   
    /* 产品选型 */
    .selectModel{
        width: 100%;
        margin-top: 20px;
    }
    .tableClass{
      border: 3px dashed #3f88f9;
      padding: 0px 15px 15px;
      box-sizing: border-box;
   
      // background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h100v100H0z' fill='none' stroke='%23000' stroke-width='2' stroke-dasharray='10 5'/%3E%3C/svg%3E");
      // background-size: 100% 100%;
      // background-color: #3f88f9;
      // background-origin: border-box;
      // background-clip: padding-box;
      // padding: 1rem;
    }
    .tableClass /deep/.el-table thead.is-group th.el-table__cell{
        font-weight: 600;
        background: #4f78b4;
        color: #fff;
    }
    .tableClass ::v-deep.el-table td.el-table__cell, ::v-deep.el-table th.el-table__cell.is-leaf{
        // border-bottom: 1px solid #b1b1b1; 
        border-bottom: 1px solid #dcdcdc; 
    }
    .tableClass /deep/.el-table{
      // border-right:  1px solid #b1b1b1;
      border-right:  2px solid #dcdcdc;
    }
    .tableClass /deep/.el-table thead tr th{
      // border: 1px solid #767676;
      border: 2px solid #e1e1e1;
      border-bottom: none;
      border-right: none;
    }
    .tableClass /deep/.el-table .el-table__body td,
    .tableClass /deep/.el-table .el-table__body th{
      // border-left: 1px solid #b1b1b1;
      border-left: 1px solid #dcdcdc;
    }
    .tableClass /deep/.el-table--border, .el-table--group{
      border:none;
      border-right: 1px solid #dcdcdc;
    }
    .tableClass /deep/.el-table .el-table__cell{
      padding: 4px 0px;
    }
    .tableClass /deep/.el-table .cell{
      padding: 0px 4px;
      line-height: 16px;
    }
    .tableClass /deep/.el-table .note{
      color: #b7b7b7;
    }
    .tableClass /deep/.el-table--border .el-table__cell:first-child .cell{
      padding-left: 4px;
    }
    .tips{
        color: #333;
        font-size: 14px;
        margin-top: 20px;
        font-weight: 600;
    }
   
    
  // 兼容分辨率----------------------------------------
    @media screen and (min-width: 2000px){
      
    }
    @media screen and (max-width: 1750px){
      
        
    }
    @media screen and (max-width: 1600px){
      
    }
    @media screen and (max-width: 1400px){
     
    }
    @media screen and (max-width: 1199px) {
      
    }
    @media screen and (max-width: 1050px) {
    
    }
    @media screen and (max-width: 800px) {
     
    }
    @media screen  and (max-width: 630px) {
     
    }
    @media screen  and (max-width: 500px) {
      
    }
    @media screen  and (max-width: 420px) {
      
    }

  </style>


